const elementosPaginaAtual = (arrayCompleto, paginaAtual, registrosPorPagina) => {
  const indiceInicioPagina = paginaAtual * registrosPorPagina - registrosPorPagina
  const indiceFimPagina = paginaAtual * registrosPorPagina
  return arrayCompleto.slice(indiceInicioPagina, indiceFimPagina)
}

export default elementosPaginaAtual
